// extracted by mini-css-extract-plugin
module.exports = {"root":"desktop-map_root__3P2Yl","closeButton":"desktop-map_closeButton__2v-Jk","mapContainer":"desktop-map_mapContainer__x3oA9"};